import React from "react";
import MixpanelService from "../../components/utils/MixpanelService";

const BillboardSupportFooter = () => {
  return (
    <>
      <div className="mt--4 t--light">Questions?</div>
      <p className="t--italic t--subtitle">Click the icon in the lower right to chat live with Beacon Support.</p>
      <div className="mt--2 t--light">Prefer to email?</div>
      <p className="t--italic t--subtitle">
        <a
          href="mailto:productsupport@mfp.beaconchannelmanagement.com"
          onClick={() => MixpanelService.track(null, "Registration_Emailed Support")}
        >
          productsupport@mfp.beaconchannelmanagement.com
        </a>
      </p>
      <div className="footer__logo__container mt--4">
        <div className="footer__logo" />
        <div className="footer__logo__name">Beacon Channel Management</div>
        <div className="footer__link__separator" />
        <div className="footer__link">
          <a href="/pages/terms-of-use" rel="noopener noreferrer">
            Terms
          </a>
        </div>
        <div className="footer__link__separator" />
        <div className="footer__link">
          <a href="/pages/privacy" rel="noopener noreferrer">
            Privacy
          </a>
        </div>
      </div>
    </>
  );
};

export default BillboardSupportFooter;
